'use client';

import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { JoinFlowButtons } from './JoinFlowButtons';
import { UpgradeFlowButtons } from './UpgradeFlowButtons';
import { JOIN_FLOW_STEPS, ProductType, TRIAL, UPGRADE_STEPS } from '@/lib/constants/maverick';
import { hasProductTypeInCartItemGroups, isMembershipAndDeviceInCartItems } from '../cart.utils';
import { useGetCurrentPageMaverick } from '@/hooks/useGetCurrentPageMaverick';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';
import { useExperimentService } from '@/hooks/experimentService';
import { EXPERIMENT_JF_PERSISTENT_CART } from '@/lib/constants/experiments';
export type CartButtonVariants = 'continueToMembership' | 'checkoutAndAddAccessories' | 'continueToCheckout' | 'continueToAccessories' | 'chooseUpgradeOption' | 'chooseUpcycleOption' | 'control';
export interface CartCTAButtonsProps {
  variant: CartButtonVariants;
  showOnlyPrimaryButton?: boolean;
  skipMemSelectFlow?: string;
  isUpcycleExperimentVariant?: boolean;
  showTrialBlock?: boolean;
}
export function CartCTAButtons({
  variant,
  showOnlyPrimaryButton = false,
  skipMemSelectFlow,
  showTrialBlock = false
}: CartCTAButtonsProps) {
  const pathname = usePathname();
  const currentPage = useGetCurrentPageMaverick();
  const isUpgradeFlow = pathname.includes('upgrade');
  const {
    getExistingVariant
  } = useExperimentService();
  const {
    cart
  } = useSiteStore(useShallow(state => ({
    cart: state.cart
  })));
  const [showCartCTAs, setShowCartCTAs] = useState(false);
  const {
    cartItemGroups
  } = cart;
  const persistentCartExperiment = getExistingVariant(EXPERIMENT_JF_PERSISTENT_CART);
  const isInCartExperiment = persistentCartExperiment === 'experiment';
  useEffect(() => {
    const showUpgradeCartCTAs = isUpgradeFlow && (currentPage === UPGRADE_STEPS.OPTIONS || currentPage === UPGRADE_STEPS.UPCYCLE || hasProductTypeInCartItemGroups(cartItemGroups, ProductType.EXTENSION) || hasProductTypeInCartItemGroups(cartItemGroups, ProductType.UPGRADE_FEE));
    const showJoinFlowCartCTAs = isMembershipAndDeviceInCartItems(cartItemGroups) || skipMemSelectFlow === TRIAL && hasProductTypeInCartItemGroups(cartItemGroups, ProductType.MEMBERSHIP) || isInCartExperiment && currentPage === JOIN_FLOW_STEPS.JOIN;
    setShowCartCTAs(showJoinFlowCartCTAs || showUpgradeCartCTAs);
  }, [cartItemGroups, currentPage, isUpgradeFlow, skipMemSelectFlow, isInCartExperiment]);

  // Render appropriate flow component with flow-specific logic
  if (isUpgradeFlow) {
    return <UpgradeFlowButtons showOnlyPrimaryButton={showOnlyPrimaryButton} variant={variant} />;
  }
  if (showCartCTAs) {
    return <JoinFlowButtons showOnlyPrimaryButton={showOnlyPrimaryButton} variant={variant} skipMemSelectFlow={skipMemSelectFlow} showTrialBlock={showTrialBlock} />;
  }
  return null;
}